import "./CheckboxSearchResults.module.scss";

import {boundMethod} from "autobind-decorator";
import {AnimatePresence, motion} from "framer-motion";
import React from "react";

import {parseNumber} from "@translate/T";
import InlineCheckbox from "../button-like/InlineCheckbox";
import {animation, onClosed, onOpen} from "../design/models";

export interface ICheckboxSearchResultsProps<TValue> {
    selected: TValue[];
    options: TValue[];

    onChange(value: TValue[]): void;
    getName(value: TValue): string;
    getId(value: TValue): string;
    isDisabled?(value: TValue): boolean;
    render2ndCol?(value: TValue): JSX.Element;
}

class CheckboxSearchResults<TValue> extends React.PureComponent<
    ICheckboxSearchResultsProps<TValue>
> {
    @boundMethod
    public onChange(checked: boolean, _id: string) {
        const {options, selected, onChange} = this.props;

        const ids = _id.split("-");
        const id = parseNumber(ids[ids.length - 1]);
        const value = options[id];

        const values = [...selected];
        if (checked) {
            values.push(value);
        } else {
            const index = values.indexOf(value);
            values.splice(index, 1);
        }

        onChange(values);
    }

    public render() {
        return (
            <div className="div-overflow-y" styleName="table-overflow">
                <table className="table table-sm table-striped table-borderless table-center">
                    <tbody>
                        <AnimatePresence exitBeforeEnter={true}>
                            {this.renderOptions()}
                        </AnimatePresence>
                    </tbody>
                </table>
            </div>
        );
    }

    private renderOptions() {
        const {options, selected, getName, getId, isDisabled, render2ndCol} =
            this.props;
        const checkeds = selected.map(getId);

        return options.map((value, i) => (
            <motion.tr
                key={getId(value)}
                animate={onOpen}
                exit={onClosed}
                initial={onClosed}
                transition={animation}
            >
                <td>
                    <InlineCheckbox
                        idSuffix={`option-${i}`}
                        checked={checkeds.includes(getId(value))}
                        disabled={isDisabled?.(value)}
                        toggle={this.onChange}
                    >
                        {getName(value)}
                    </InlineCheckbox>
                </td>
                {render2ndCol !== undefined && <td>{render2ndCol(value)}</td>}
            </motion.tr>
        ));
    }
}

export default CheckboxSearchResults;
